/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';
import { useParams } from 'react-router-dom';
import PropTypes from 'prop-types';
import { Grid } from 'semantic-ui-react';
import LineChart from 'components/common/charts/LineChart/Container';
import {
  greenColor,
  blueColor,
  orangeColor,
  redColor,
} from 'utils/chartColors';
import { cleanCumulative } from 'helpers/toCumulativeDates';
import todaysDate from 'utils/todaysDate';
import currencyFormat from 'utils/currencyFormat';
import toMonthStat from 'helpers/toMonthStat';
import formatNumber from 'helpers/formatNumber';

const LineCharts = ({ data = {}, year }) => {
  const {
    groups_count: groupsCount,
    groups = [],
    agents_count: agentsCount,
    agents: cumulativeAgents = [],
    current_savings: savings = [],
    current_savings_total: savingsBalance,
    current_loans: outstandingLoans = [],
    current_loans_total: outstandingLoansCount,
  } = data;

  const { tab } = useParams();

  return (
    <Grid>
      <Grid.Row columns="2">
        <Grid.Column width="8">
          <LineChart
            {...{
              title: 'Saving Groups',
              viewKey1: 'groups',
              view: `${tab || 'organization'}`,
              date: todaysDate(year),
              amount: formatNumber(groupsCount),
              data: groups,
              background: greenColor,
              dataKey: 'count',
            }}
          />
        </Grid.Column>
        <Grid.Column width="8">
          <LineChart
            {...{
              title: 'Agents',
              viewKey1: 'agents',
              view: `${tab || 'organization'}`,
              date: todaysDate(year),
              amount: formatNumber(agentsCount),
              data: cleanCumulative(cumulativeAgents),
              background: blueColor,
              dataKey: 'uv',
            }}
          />
        </Grid.Column>
      </Grid.Row>
      <Grid.Row columns="2">
        <Grid.Column width="8">
          <LineChart
            {...{
              title: 'Current Savings',
              viewKey1: 'groups',
              view: `${tab || 'organization'}`,
              date: todaysDate(year),
              amount: `${currencyFormat(savingsBalance)}`,
              data: toMonthStat(savings),
              background: orangeColor,
              dataKey: 'count',
            }}
          />
        </Grid.Column>
        <Grid.Column width="8">
          <LineChart
            {...{
              title: 'Outstanding loans',
              viewKey1: 'groups',
              view: `${tab || 'organization'}`,
              date: todaysDate(year),
              amount: `${currencyFormat(outstandingLoansCount)}`,
              data: outstandingLoans,
              background: redColor,
              dataKey: 'count',
            }}
          />
        </Grid.Column>
      </Grid.Row>
    </Grid>
  );
};

LineCharts.propTypes = {
  data: PropTypes.objectOf(Object).isRequired,
};

export default LineCharts;
